module.exports = __webpack_public_path__ + "static/img/img_map_01.ddaa51d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dali/img_map_01.png
// module id = Bg3f
// module chunks = 19